// Removed Ant Design icon import
// Removed Result import
import { API } from 'aws-amplify';
import QueryString from 'query-string';
// Added CBResult, CBSpin imports
import { CBResult } from '../../core/components/CBResult';
import { CBSpin } from '../../core/components/CBSpin';
import { useEffect, useState } from 'react';
import { useGlobalState } from '../../../store';



const ScheduleBookingAuthPage = () => {
  const [showList, setShowList] = useState(false)
  const [callbackStatus, setCallbackStatus] = useState('loading')
  const [errorMessage, setErrorMessage] = useState(null)
  const [, setAccounts] = useGlobalState('accounts')
  const [, setLoadingCoreData] = useGlobalState('loadingCoreData')

  useEffect(() => {
    let params = QueryString.parse(window.location.search)

    if (params.code) {
      if(params.scope && params.scope.includes("google")){

        codeCallbackAccountCreation(params.code, "google", params.state,params.scope)
      } else {

        codeCallbackAccountCreation(params.code, "ms", params.state,params.scope)
      }
    } else {
      setErrorMessage('/book/' + params.state)
    }
  }, [])

  const codeCallbackAccountCreation = async (code, type, state,scope) => {
    
    try{
    var auth = await API.post('group-bookings', '/group-bookings?auth=true', {
      body: {
        code,
        type,
        scope,
        state,
        redirect:
          type === 'ms'
            ? window.location.origin + process.env.REACT_APP_OAUTH_O365_URL_BOOK
            : window.location.origin + process.env.REACT_APP_OAUTH_GOOGLE_URL_BOOK,
      },
    })
    //console.log(auth)
    localStorage.setItem("cal_auth_email",auth.email)
    localStorage.setItem("cal_auth_account",auth.account.calendarAccountId)
    localStorage.setItem("cal_auth_account_type",auth.account.calendarAccountType)
    if(state.includes("external")) {
      
      var redirect = auth.account.displayName
      
      // auth.account.displayName !="" // redirect to that which will be the internal app url
      if(redirect.startsWith("cb_web")){
        console.log("REDIRECT EXTERNAL IFRAME")
        localStorage.setItem("scheduler_id",auth.account.errorState)
        window.location.href = window.location.origin + '/external/edit/?schedulerId=' + auth.account.errorState + "&session=" + redirect.split(":")[1] // +edit token?
      } else {
        console.log("REDIRECT EXTERNAL APP")
        window.location.href = redirect //+ "?schedulerId=" + auth.account.errorState  // redirect for mobile app
      }
      
    } else
    if(state.includes("@")) {
      window.location.href = window.location.origin + '/dashboard/group/new'
    } else {
    window.location.href =  state //window.location.origin + '/book/' +
  }
    } catch(error) {
      // redirect back to app
      if(state.includes("external")) {
        var errorCode = error.response.data.error
        var callback = error.response.data.redirect
        if(callback.includes("?")) {
          window.location.href = (callback + "&error=" + errorCode)
        }else {
          window.location.href = (callback + "?error=" + errorCode)
        }
        
      } else {
        setErrorMessage('/book/' + state)
      }
      
    }

  }

  function renderError() {
    return (
      // Replaced Result with CBResult
      <CBResult
        status="warning"
        title="Darn! We had trouble linking your account."
        subTitle={errorMessage}
        // extra prop can be omitted if empty
      />
    )
  }
return (
  <div className="text-center pt-24"> {/* Use Tailwind */}
    {errorMessage && (renderError())}
    {/* Replaced icon with CBSpin */}
    {!errorMessage && (
      <CBSpin
        spinning={true}
        size="large"
        
      />
    )}
</div>
);

  
}


export default ScheduleBookingAuthPage
